import {SkeletonBlock} from '@aboutyou/ui-components';
import React, {Fragment} from 'react';

export const LoadingPlaceholder = () => {
  return (
    <Fragment>
      <SkeletonBlock $width="400px" $height="100px" />
      <SkeletonBlock $width="400px" $height="100px" />
      <SkeletonBlock $width="400px" $height="100px" />
    </Fragment>
  );
};
